import BaseClass from './BaseClass'
import axios from '../axios'

export default class WAL_Publications extends BaseClass {
  constructor() {
    super('api/walmart/publications/')
  }

  async get(id) {
    return await axios.get(`${this.urlBase}${id}`)
  }

  async delete(id) {
    return await axios.delete(`${this.urlBase}${id}`)
  }

  async updateMassiveStock() {
    return await axios.patch(`${this.urlBase}update-massive-stock`)
  }

  async getPublicationsViaApi() {
    return await axios.get(`${this.urlBase}products/walmart`)
  }

  async saveStock(sku, stock) {
    return await axios.patch(`${this.urlBase}${sku}/stock/${stock}`)
  }

  async getStockErp(sku) {
    return await axios.get(`${this.urlBase}stock/${sku}/erp`)
  }

  async getStockApi(sku) {
    return await axios.get(`${this.urlBase}stock/${sku}/api`)
  }

  async show(sku) {
    return await axios.get(`${this.urlBase}${sku}`)
  }

  async getInformation(datum) {
    return await axios.get(`${this.urlBase}products/sku/${datum.sku}`)
  }

  async pause(id) {
    return await axios.patch(`${this.urlBase}${id}/pause`)
  }

  async deletePublication(id) {
    return await axios.delete(`${this.urlBase}${id}/delete`)
  }
}
